/* eslint-disable global-require */
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import RuntimeApp from './runtime/App';

import '../platformAssets/runtime/fontManager';

export default () => (
    <Provider store={store}>
        <RuntimeApp />
    </Provider>
);
